import React, { ReactElement } from 'react';
import '../../styles/fadeIn.css';
import { makeStyles, Typography, Container, Button } from '@material-ui/core';
import { Fade, Slide } from 'react-awesome-reveal';
import SocialFeedCard from '../../components/SocialFeedCard';
import bannerImg from './front-banner.png';
import bloomProject from './bloomProject.png';
import { Link, useHistory } from 'react-router-dom';
import { menu } from '../../data';
import { newsArticles } from '../../config';

const useStyles = makeStyles((theme) => ({
    firstBanner: {
        width: '100%',
        height: '95vh',
        color: 'white',
        backgroundImage: `url("${bannerImg}")`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        [theme.breakpoints.down('md')]: {
            paddingBottom: '10rem',
        },
    },
    firstBannerContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '10rem',
        [theme.breakpoints.down('lg')]: {
            marginTop: '4rem',
        },
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
        },
    },
    menuLink: {
        textDecoration: 'none',
        margin: '2rem 0',
        display: 'flex',
    },
    menuText: {
        borderBottom: '1px solid white',
        color: 'white',
        [`&:hover`]: {
            color: theme.palette.primary.light,
            borderBottom: `1px solid ${theme.palette.primary.light}`,
        },
    },
    secondBanner: {
        width: '100%',
        display: 'flex',
        padding: '8rem 0',
        justifyContent: 'space-between',
        color: 'white',
        backgroundColor: '#cc4800',
        [`& button`]: {
            fontSize: '1.5rem',
            margin: '1rem auto',
            textTransform: 'none',
        },
        [`& h4`]: {
            margin: '2rem 0',
        },
        [theme.breakpoints.down('lg')]: {
            padding: '4rem 0',
        },
        marginBottom: '2rem',
    },
    thirdBannerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        [`& button`]: {
            marginTop: '2rem',
        },
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
            margin: '3rem 0',
        },
    },
    thirdBannerTextContainer: {
        maxWidth: 300,
        [theme.breakpoints.down('sm')]: {
            maxWidth: 400,
        },
    },
    latestFeedContainer: {
        [`& h3`]: {
            margin: '2rem 0',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    fourthBanner: {
        backgroundImage: `url("${bloomProject}")`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        padding: '20rem 0',
        marginTop: '8rem',
        display: 'flex',
        justifyContent: 'center',
        color: 'white',
        [`& h4`]: {
            marginBottom: '2rem',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '12rem 0',
            marginTop: '3rem',
        },
    },
}));

const latestNews = newsArticles[0];

function Home(): ReactElement {
    const classes = useStyles();
    const history = useHistory();

    return (
        <div>
            <div className={classes.firstBanner}>
                <Container className={classes.firstBannerContainer} maxWidth="md">
                    <div className="fade-in">
                        {menu.map((menuItem) => (
                            <Link className={classes.menuLink} key={menuItem.name} to={menuItem.link}>
                                <Typography className={classes.menuText} variant="h2">
                                    {menuItem.name}
                                </Typography>
                            </Link>
                        ))}
                    </div>
                </Container>
            </div>
            <div className={classes.secondBanner}>
                <Container maxWidth="md">
                    <Fade triggerOnce>
                        <Typography align="center" variant="h4" component="h4">
                            Over 40 years experience working in the heart of London, all over the UK and Europe
                        </Typography>
                        <Typography align="center" variant="h4" component="h4">
                            Currently we have over 50 experienced and hardworking persons on our team and we grow
                            stronger every year
                        </Typography>
                        <Typography align="center">
                            <Button onClick={(): void => history.push('/services')} color="inherit" variant="outlined">
                                View our Services
                            </Button>
                        </Typography>
                    </Fade>
                </Container>
            </div>
            <Container className={classes.thirdBannerContainer} maxWidth="md">
                <Slide triggerOnce direction="left">
                    <div className={classes.thirdBannerTextContainer}>
                        <Typography variant="h4">
                            Constantly growing and actively working on all kinds of projects
                        </Typography>
                        <Button onClick={(): void => history.push('/news')} variant="outlined">
                            View our news feed
                        </Button>
                    </div>
                </Slide>
                <Slide triggerOnce direction="right">
                    <div className={classes.latestFeedContainer}>
                        <Typography component="h3" variant="h3">
                            Latest feed
                        </Typography>
                        <SocialFeedCard
                            text={latestNews.text}
                            date={latestNews.date}
                            imageUrl={latestNews.imageUrl}
                            linkedinUrl={latestNews.linkedinUrl}
                        />
                    </div>
                </Slide>
            </Container>
            <div className={classes.fourthBanner}>
                <Fade triggerOnce>
                    <Container maxWidth="sm">
                        <Typography component="h4" align="center" variant="h4">
                            Our project list is growing
                        </Typography>
                        <Typography align="center">
                            <Button onClick={(): void => history.push('/projects')} color="inherit" variant="outlined">
                                View our projects
                            </Button>
                        </Typography>
                    </Container>
                </Fade>
            </div>
        </div>
    );
}

export default Home;
